// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3U_Rt","title":"InfoRow_title__2nVVz"};